export const routePaths = {
  Home: '/',
  Summary: '/summary-screen',
  InspectionDate: 'inspection-date',
  ExecutiveSummary: 'executive-summary',
  TableOfBucket: '/table-of-bucket-screen',
  NewInspection: '/new-inspection',
  NewBucket: '/new-bucket',
  InspectionBasePath: '/inspections/:externalId',
  SupportScreen: '/support-screen',
  HelpScreen: '/help-screen',
  OperationHours: 'operating-hours',
  MachinePhoto: 'machine-photo',
};
